<template>
  <div class="expandable-summary-row" :class="{'out-of-date': outOfDate, 'expanded': isExpanded }" :id="id">
    <div class="sections-label" :class="{'predicted-category-expanded-shadow': isExpanded && withShadow,
     'not-clickable': !isExpandable}"
         v-on:click="toggleExpend()">
      <div class="header-text" :class="textStyle"  v-if="headerText">{{ headerText }}</div>
      <slot name="header"></slot>
      <expand-arrow v-if="isExpandable" :expanded="expanded" :greyed-out="outOfDate" :size="arrowSize"/>
    </div>
    <collapse-transition>
      <div v-show="isExpanded">
        <slot name="content"></slot>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import EventBus from '@/event-bus/event-bus';
import effectsUtils from '@/store/utilities/effects';
import ExpandArrow from '../../../../../../../../../base-components/ExpandArrow';

function _randomString() {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);
}

export default {
  name: 'ExpandableSummaryRow',
  components: {
    ExpandArrow,
    CollapseTransition: BaseUI.CollapseTransition,
  },
  props: {
    headerText: {
      type: String,
      required: false,
    },
    isExpandable: {
      type: Boolean,
      default: true,
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
    arrowSize: {
      type: String,
      required: false,
      validator: val => ['medium', 'small'].includes(val),
    },
    textStyle: {
      type: String,
      required: false,
      validator: val => ['medium', 'small'].includes(val),
      default: 'small',
    },
    withShadow: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      expanded: this.initiallyExpanded,
      id: null,
    };
  },
  created() {
    this.id = _randomString();
    EventBus.$on('expand-to-edit', ({ type }) => {
      if (type === this.type) {
        this.expanded = true;
        effectsUtils.scrollToElement(this.id);
      }
    });
  },
  computed: {
    isExpanded() {
      return this.expanded && this.isExpandable;
    },
  },
  methods: {
    toggleExpend() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.$emit('expanded');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '~base-ui/src/scss/riseup-vars';
@import '../../../../../../../../../scss/mixins';

.expandable-summary-row {
  .sections-label {
    color: $riseup_black;
    display: grid;
    width: 100%;
    cursor: pointer;
    font-size: 14px;
    grid-template-columns: 1fr 13px;
    column-gap: 10px;
    padding: 0 17px 0 24px;
    align-items: center;

    .header-text {
      font-weight: bold;
      font-size: 14px;
      padding: 18px 7px 18px 0;

      &.medium {
        font-size: 18px;
      }
    }

    &.not-clickable {
      cursor: default;
    }

    &.predicted-category-expanded-shadow {
      margin-bottom: 3px;
      box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.15);
    }
  }

  &.out-of-date {
    color: $riseup_gray_2;
    .header-text {
      color: $riseup_gray_2;
    }
  }
}

</style>
